var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMailIconGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20648 19.3712C4.55898 19.7237 4.98273 19.9 5.47773 19.9H13.1777V18.1H5.47773V9.1L12.6777 13.6L19.8777 9.1V11.5H21.6777V7.3C21.6777 6.805 21.5015 6.38125 21.149 6.02875C20.7965 5.67625 20.3727 5.5 19.8777 5.5H5.47773C4.98273 5.5 4.55898 5.67625 4.20648 6.02875C3.85398 6.38125 3.67773 6.805 3.67773 7.3V18.1C3.67773 18.595 3.85398 19.0187 4.20648 19.3712ZM19.8777 7.3L12.6777 11.8L5.47773 7.3H19.8777Z",
    fill: "#498e2b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1777 13.5L18.1777 16.125L14.6777 16.125L14.6777 17.875L18.1777 17.875L18.1777 20.5L21.6777 17L18.1777 13.5Z",
    fill: "#498e2b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMailIconGreen);
export default __webpack_public_path__ + "static/media/sendMailIcon-green.757272a344d6b4e20b98fdbfde959804.svg";
export { ForwardRef as ReactComponent };